import useTranslation from 'next-translate/useTranslation';
import NextLink from 'next/link';

import { Button, Icon, Link, SeeMore } from '@/atoms';
import { Card } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypeMapCardProps } from './types';

/**
 * MapCard
 */
export const MapCard: FunctionComponent<TypeMapCardProps> = ({
  className = '',
  buttonVariant = 'primary',
  buttonText,
  caption,
  characteristicsList,
  subtitle,
  title,
  orientation,
  mapIframe,
  numberOfElements,
  link,
}: TypeMapCardProps) => {
  const { t } = useTranslation('common');

  return (
    <Card
      multimediaProps={{
        src: mapIframe,
        popUp: true,
        descPopUp: subtitle,
        popUpTitle: title,
      }}
      orientation={orientation}
      className={`bg-white  ${className}`}
    >
      <div className="flex flex-col gap-1 text-primary-400">
        {caption && (
          <span className="text-caption text-caption--small">{caption}</span>
        )}
        <h3 className="text-heading text-heading--h3">{title}</h3>
        {subtitle && (
          <span className="text-body text-body--secondary font-bold">
            {subtitle}
          </span>
        )}
      </div>
      <div
        className={`mb-2 mt-8 text-primary-400
        ${
          orientation === 'column' ? 'flex flex-col' : 'grid grid-cols-2 gap-4 '
        }`}
      >
        <SeeMore
          labels={{
            viewLess: t('components.atoms.seeMore.labels.viewLess'),
            viewMore: t('components.atoms.seeMore.labels.viewMore'),
          }}
          icon="ArrowDownPri"
          expanded={false}
          variant="primary"
          numberOfElements={numberOfElements}
        >
          {characteristicsList.map((element, index) => (
            <div key={index} className="flex flex-row items-center gap-2">
              {/** Cambiar como se reciben los iconos del back */}
              <Icon
                className="text-primary-400"
                height={16}
                width={16}
                src={element.icon}
              />
              <span className="text-body text-body--secondary ">
                {element.text}
              </span>
            </div>
          ))}
        </SeeMore>
      </div>
      {buttonText && (
        <div className="border-t border-primary-400 pt-4">
          <NextLink href={link} passHref prefetch={false}>
            <Button
              as="a"
              className="!w-full"
              variant={buttonVariant}
              size="large"
            >
              <Link arrow={true} as="span" variant="alternative">
                {buttonText}
              </Link>
            </Button>
          </NextLink>
        </div>
      )}
    </Card>
  );
};

MapCard.displayName = 'MapCard';
